// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__23Fbf","errorLogs":"styles_errorLogs__IYa8J"};